module.exports = __webpack_public_path__ + "img/VL_15_02.a3a52e21.png";